import { __awaiter } from '../_virtual/_tslib.js';
import { toast } from '../components/toast/toast.js';
import { LOC_STORAGE } from '../constants/misc.js';
import API from './const.js';

function sendCallbackRequest({ PhoneNumber, name, remarks }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const call = yield fetch(new Request(API.CALL_BACK_REQUEST, {
                method: "POST",
                body: JSON.stringify({
                    subject: `Call Me: ${PhoneNumber}: ${name ? name : "Guest"}`,
                    content: remarks,
                    owner_id: "84025938"
                })
            }));
            const { posts, meta } = yield call.json();
            if (call.status === 200) {
                window.localStorage.setItem(LOC_STORAGE.callbackRequestedTimestamp, new Date().toISOString().toString());
                return { posts, meta, status: call.status };
            }
        }
        catch (error) {
            toast.error("An error occured, please try again after sometime", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });
        }
        return { posts: null, meta: null, status: null };
    });
}
// export async function customer2CustomerCallbackRequest({
//     phoneNumber,
//     transporterCompanyId
// }: Customer2CustomerCallbackRequestProps) {
//     try {
//         const callbackResponse = await fetch(
//             new Request(API.C2C_CALLBACK, {
//                 method: "POST",
//                 body: JSON.stringify({
//                     company_id: String(transporterCompanyId),
//                     phone_number: String(phoneNumber),
//                     type: "2"
//                 })
//             })
//         );
//         const { data } = await callbackResponse.json();
//         if (data.status === "success") {
//             return true;
//         } else {
//             throw "";
//         }
//     } catch (error) {
//         toast.error("The transporter you are trying to call is no longer active");
//     }
//     return false;
// }
function newCustomer2CustomerCallbackRequest({ callerId, calleeId, referenceId, referenceType }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (true) {
                throw { err: "Service Not Available" };
            }
            // if (!callerId || !calleeId || true) {
            //     throw { err: "Something went wrong!" };
            // }
            // const callbackResponse = await fetch(
            //     new Request(API.C2C_CALLBACK, {
            //         method: "POST",
            //         body: JSON.stringify({
            //             caller_id: callerId,
            //             callee_id: calleeId,
            //             reference_id: referenceId,
            //             reference_type: referenceType
            //         }),
            //         headers: {
            //             Accept: "application/json",
            //             "Content-Type": "application/json",
            //             ...getAuthHeader()
            //         }
            //     })
            // );
            // const { data } = await callbackResponse.json();
            // if (data?.virtual_number) {
            //     return data.virtual_number;
            // } else {
            //     throw "";
            // }
        }
        catch (error) {
            if (error === null || error === void 0 ? void 0 : error.err) {
                toast.error(error.err);
                return;
            }
            toast.error("Please try after sometime.");
        }
        return false;
    });
}

export { newCustomer2CustomerCallbackRequest, sendCallbackRequest };
//# sourceMappingURL=callBack.service.js.map
